import { instance } from '@/libs/api/instance'

/**
 * Get notification by id
 * @param id
 *
 * @return {Promise<AxiosResponse<any>>}
 */
export const getNotification = async (id) => {
  return instance.get(`/v2/notification/${id}`)
}
